/**
 * GA管理用クラス
 */

class GAManager {
  // ---------------------------------------------------------------------------------------------------------
  // --	GAManager
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    console.log("GAManager");
  }

  ready() {
    console.log("GAManager.ready");
    console.log(window.dataLayer);
    window.dataLayer = window.dataLayer || [];
  }

  gtag(action, label) {
    const data = {
      event: "quizCount",
      category: "quizCount",
      quizAction: action,
      quizLabel: label,
    };
    dataLayer.push(data);
    console.log(window.dataLayer);
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default new GAManager();
